<template>
  <div>
    <!-- Retried Campaign Contents -->
    <div
      class="row flex-row flex-nowrap justify-content-center"
      style="overflow-x: hidden"
    >
      <!-- Left Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->

      <!-- Retried Campaign Contents Card -->
      <div class="card shadow customs-card mx-2">
        <!-- Retried Campaign Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            リトライ済キャンペーン
          </p>
        </div>

        <div class="card-body px-5 py-4">
          <div>
            <p class="text-justify mb-0 font-weight-bold text-bold text-color" v-html="campaign.name">
              <!--{{ campaign.name }}-->
            </p>
            <div class="text-justify text text-color mb-0">
              応募日 : {{ campaign.date }}
            </div>
          </div>
        </div>

        <!-- Retry Campaign Label  -->
        <div
          class="card-footer border-0"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
            background-color: #dfdfdf !important;
          "
        >
          <p class="text-center mb-0 font-weight-bold text-bold text-color">
            リトライ済
          </p>
        </div>
      </div>

      <!-- Right Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->
    </div>

    <!-- Cautions Label and Cautions Details -->
    <cautions :cautions="cautions"></cautions>
  </div>
</template>

<script>
import { enretryCampaign } from "@/api/campaign";
import { getUserId } from "@/utils/auth";
import { getCampaignId, getCampaignCautions } from "@/utils/campaign";
import { setErrorMessage } from "@/utils/error";
import Cautions from "@/components/Cautions.vue";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      campaign: {
        name: "",
        date: "",
      },
      cautions: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    const query = {
      user_id: getUserId(),
      campaign_id: getCampaignId(),
    };

    // get Retry Entry Campaign data from api and set to data
    enretryCampaign(query)
      .then((response) => {
        // console.log(JSON.stringify(response));
        if (response.status === "success") {
          return next((vm) => {
            // set campaign data (name, description, caution, application_date)
            vm.setData(response);

            // set caution data
            vm.setCampaignCautions(response.caution);
          });
        } else {
          throw new Error(response);
        }
      })
      .catch((error) => {
        return next("/not-permission");
      });
  },
  methods: {
    setData(response) {
      this.campaign.name = response.result.name || "";
      this.campaign.date = response.result.application_date || "";
    },
    setCampaignCautions(cautions) {
      this.cautions = cautions;
    },
  },
};
</script>

<style scoped>
.cautions-background {
  background-color: #dddddd;
}
</style>
